import React, { Fragment } from 'react';

import Image from 'components/Image';

import ProfileLink from '../ProfileLink';
import PossibleDisplayQuality from '../PossibleDisplayQuality';

import myselfProfilePropTypes from '../prop-types';

export default function ProfileMdUp({
  avatarImage,
  canChangeFaceForFree,
  changeJournalPrivacy,
  journalIsPrivate,
  mantelpieceItemId,
  name,
  scrapbookStatusId,
  viewCameos,
}) {
  return (
    <Fragment>
      <h2 className="heading heading--2 myself-profile__header">Cameo &amp; Profile</h2>
      <div className="myself-profile--medium">
        <div className="myself-profile__cameo-and-button">
          <Image
            borderContainerClassName="myself-profile__cameo-border myself-profile__cameo-border--md-up"
            className="myself-profile__cameo myself-profile__cameo--md-up"
            icon={avatarImage}
            alt="You"
            type="cameo"
            border
          />
          <button
            type="button"
            onClick={viewCameos}
            className="button button--primary u-space-above"
          >
            {canChangeFaceForFree ? 'Change face' : 'View cameos'}
          </button>
        </div>
        <div className="myself-profile__panel">
          <div className="myself__display-qualities">
            <div className="myself__display-quality">
              <h3 className="heading heading--3">Mantelpiece</h3>
              <div className="display-quality__item">
                <PossibleDisplayQuality
                  itemId={mantelpieceItemId}
                  nature="Thing"
                />
              </div>
            </div>
            <div className="myself__display-quality">
              <h3 className="heading heading--3">Scrapbook</h3>
              <div className="display-quality__item">
                <PossibleDisplayQuality
                  itemId={scrapbookStatusId}
                  nature="Status"
                />
              </div>
            </div>
          </div>
          <div className="myself-profile__view-and-set-private">
            <ProfileLink name={name} />
            <label>
              <input name="hideProfile" type="checkbox" checked={journalIsPrivate} onChange={changeJournalPrivacy} />
              Private
              <div
                className="js-buttonlet-help buttonlet buttonlet--help fa-stack js-tt"
                title="Checking this will prevent you from appearing as a suggested contact for social actions"
                style={{ position: 'relative' }}
              >
                <i className="fa fa-circle fa-stack-2x" />
                <i className="fa fa-question fa-stack-1x fa-inverse" />
                <span className="u-visually-hidden">Help</span>
              </div>
            </label>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

ProfileMdUp.displayName = 'ProfileMdUp';

ProfileMdUp.propTypes = {
  ...myselfProfilePropTypes,
};